import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from 'app/shared/constant/constants';
import { AddBankAccountRequest } from 'app/modules/bank-account/models/bank-account.model';
import { RemittanceService } from 'app/modules/remittance/services/remittance.service';
import { BankAccountService } from 'app/modules/bank-account/services/bank-account.service';
import { CardService } from '../../services/card.service';
import { OrderService } from 'app/modules/order/services/order.service';
import { ToastrService } from 'ngx-toastr';
import { CryptoUtils } from 'app/shared/utility/crypto.utils';
import { ConstantsKey } from 'app/shared/constant/constants-keys';



@Component({
  selector: 'link-buy-esim',
  templateUrl: './link-buy-esim.component.html',
  styleUrls: ['./link-buy-esim.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LinkBuyEsimComponent implements OnInit {
  public showLoader: boolean = false;

  isChecked: boolean = false; 
  isFormSubmitted: boolean = false;
  relationship: string = '';

  public paymentMode;
  public bankAccountId: any;
  public bankDropdownItemList: any;
  public bankRelationshipList = Constants.payerList;
  public addBankAccountRequest = new AddBankAccountRequest();
  public bankAccountList: any;      
  public modalReference: any;

  public eSIMOrderId: any;
  public simType: any = 'E-SIM';
  public cryptoUtils: CryptoUtils = new CryptoUtils();
  public eSIMSelectedPackage: any;
  public eSIMOrderData;
  activeTab = 'iosDevices';
  public isRetryPayment = false;
   
  @ViewChild('devicesModal') devicesModal: any;
  @ViewChild('eSIMCardModal') eSIMCardModal: any;
  @ViewChild('eSimSuccessModal') eSimSuccessModal: any;


  iosItems: string[] = [
    'iPhone 16, 16 Plus, 16 Pro, 16 Pro Max',
    'iPhone 15, Plus, Pro, Pro Max',
    'iPhone 14, Pro, Pro Max, Plus',
    'iPhone 13, Mini, Pro, Pro Max',
    'iPhone 12, Mini, Pro, Pro Max',
    'iPhone 11, Pro, Pro Max',
    'iPhone XS, XS Max, XR',
    'iPhone SE (2020, 2022)'
    ];
    
     
    
    androidItems: string[] = [
    
    'Galaxy S23, S23+, S23 Ultra',
    
    'Galaxy S22, S22+, S22 Ultra',
    
    'Galaxy S21, S21+, S21 Ultra, 5G',
    
    'Galaxy S20, S20+, S20+ 5G, S20 Ultra 5G, S20 Ultra',
    
    'Galaxy Note 20',
    
    'Galaxy Z',
    
    'Galaxy Note 20 Ultra',
    
    'Galaxy A54 5G',
    
    'Pixel 2, 2 XL',
    
    'Pixel 3, 3 XL, 3a, 3a XL',
    
    'Pixel 4, 4a, 4 XL',
    
    'Pixel 5, 5a',
    
    'Pixel 6, 6a, 6 Pro',
    
    'Pixel 7, 7a, 7 Pro',
    
    'Pixel 8, 8 Pro',
    
    'Pixel Fold',
    
    'OPPO Find X3 Pro',
    
    'OPPO Find N2 Flip',
    
    'OPPO Reno 5A',
    
    'OPPO Reno 6 Pro 5G',
    
    'OPPO Reno 9A',
    
    'OPPO Find X5, Find X5 Pro',
    
    'OPPO A55s 5G',
    
    'Sony Xperia 10 III Lite',
    
    'Sony Xperia 10 IV',
    
    'Xperia 10V',
    
    'Xperia 1 IV',
    
    'Sony Xperia 5 IV',
    
    'Sony Xperia 1 V',
    
    'Sony Xperia Ace III',
    
    'Sony Xperia 5 V',
    
    'Xiaomi 12T Pro',
    
    'Xiaomi 13, 13 Lite, 13 Pro, 13T Pro',
    
    'Huawei P40, P40 Pro',
    
    'Huawei Mate 40 Pro',
    
    'Huawei Mate Xs, Xs2',
    
    'Huawei P70, P70 Pro and P70 Art',
    
    'Motorola Razr 2019, Razr 5G',
    
    'Motorola Razr 40, Razr 40 Ultra',
    
    'Motorola Razr+',
    
    'Motorola Edge+',
    
    'Motorola Edge 40, Edge 40 Pro, Edge 40 Neo',
    
    'Motorola G52J 5G',
    
    'Motorola G52J 5G Ⅱ',
    
    'Motorola G53J 5G',
    
    'Moto G54 5G',
    
    'Motorola G84',
    
    'Samsung Galaxy S24, S24 Plus, S24 Ultra, S24 FE',
    
    'Samsung Galaxy Fold',
    
    'Samsung Galaxy Z Fold2 5G',
    
    'Samsung Galaxy Z Fold3 5G',
    
    'Samsung Galaxy Z Fold4',
    
    'Samsung Galaxy Z Fold5 5G',
    
    'Samsung Galaxy Z Fold6 5G',
    
    'Samsung Galaxy Z Flip',
    
    'Samsung Galaxy Z Flip3 5G',
    
    'Samsung Galaxy Z Flip4',
    
    'Samsung Galaxy Z Flip5 5G',
    
    'Samsung Galaxy Z Flip6 5G',
    
    'Samsung Galaxy A55 5G',
    
    'Samsung Galaxy A35',
    
    'Google Pixel 9, 9 Pro, 9 Pro XL',
    
    'Oppo Find X3, X8, X8 Pro',
    
    'Oppo Find N3, N3 Flip',
    
    'Xiaomi 14, 14 Pro, 14T, 14T Pro',
    
    'Xiaomi Redmi Note 13 Pro+',
    
    'Motorola Edge 2022, Edge 2023, Edge+ 2023',
    
    'Motorola Edge 50 Pro, Ultra, Fusion',
    
    'Motorola Moto G Power 5G',
    
    'Motorola G34',
    
    'Motorola Razr 2024, Razr+ 2024',
    
    'Motorola Moto G Stylus 5G 2024',
    
    'Honor Magic 4 Pro, 5 Pro, 6 Pro',
    
    'Honor 90',
    
    'Honor X8',
    
    'Honor 200, 200 Pro',
    
    'Honor Magic V2, V3',
    
    'OnePlus 11, 12 ,13',
    
    'Nokia XR21, X30, g60',
    
    'Vivo X80 Pro, X90 pro, X100 Pro',
    
    'Vivo V29, V29 Lite, V29 Lite 5G',
    
    'Vivo V40, V40 Lite, V40 SE',
    
    'OUKITEL WP30 Pro, WP33 Pro',
    
    'Nuu X5',
    
    'ZTE Nubia Flip',
    
    'TLC 50 5G',
    
    'Asus ROG Phone 9, 9 Pro',
    
    'HAMMER Blade 3, 5G',
    
    'HAMMER Explorer PRO',
    
    'Gemini PDA',
    
    'Fairphone 4, 5',
    
    'DOOGEE V30',
    
    'Sharp AQUOS sense4 lite, Sense6s, sense 7, sense 7plus',
    
    'Sharp AQUOS Wish, Wish 2, wish 3',
    
    'AQUOS zero 6',
    
    'Simple Sumaho6',
    
    'Sharp AQUOS R7, R8, R8 Pro',
    
    'Rakuten Mini',
    
    'Rakuten Big, Big-S',
    
    'Rakuten Hand, Hand 5G'
    
    ];

    public NBPaymentHtml: string = "";
    public NBPaymentInProcees: boolean = false;
     
    setActiveTab(tabName: string) {
      this.activeTab = tabName;
    }

  constructor(
    public router: Router,
    private modalService: NgbModal,
    public remittanceService: RemittanceService,
        public bankAccountService: BankAccountService,
        private cardService: CardService,
        public orderService: OrderService,
        public toast: ToastrService,
  ) { }

  ngOnInit() {
    let prevPage = sessionStorage.getItem(ConstantsKey.PREV_PAGE_URL);
    let isESIMProcess = false;
    window.addEventListener('pageshow', (event) => {
      console.log("================================================================================= ESIM PAGE");
      let orderProcessStatus = localStorage.getItem(ConstantsKey.IS_ESIM_ORDER_DONE);
      if (orderProcessStatus && orderProcessStatus == "IN_PROCESS") {
        //window.location.reload(); //clean and reliable
        let orderData = localStorage.getItem(ConstantsKey.CURRENT_ORDER_TYPE);
        orderData = JSON.parse(orderData);
        let esimOrderId = orderData["ORDER_ID"];
        localStorage.removeItem(ConstantsKey.IS_ESIM_ORDER_DONE);
        this.router.navigate(["/add-on/order-details/esim/", esimOrderId]);
        isESIMProcess = true;
      }
    });

    if(isESIMProcess == false) {
        if (prevPage.includes("/add-on/order-details/esim/")) {
          let retryPayOrderData = JSON.parse(sessionStorage.getItem(ConstantsKey.ADD_ON_RETRY_PAY_ORDER));
          this.eSIMOrderData = retryPayOrderData.orderData;
          this.eSIMOrderId = retryPayOrderData.orderId;
          this.isRetryPayment = true;
        } else {
          this.eSIMSelectedPackage = JSON.parse(sessionStorage.getItem(ConstantsKey.SELECTED_ESIM));
          this.eSIMOrderData = JSON.parse(sessionStorage.getItem(ConstantsKey.ESIM_ORDER_DATA));
        }

        this.getProfileList();
        this.getBankList();
        this.getBankAccountList();
    }

  }

  getSelectedBankAccountID(id) {
    this.bankAccountId = id;
  }

  getBankList() {
    var singleObject;
    var localBankDropdownItemList;
    this.bankAccountService.getPaymentModes().subscribe(res => {

      localBankDropdownItemList = res.body;
      for (let i = 0; i < localBankDropdownItemList.length; i++) {
        singleObject = localBankDropdownItemList[i];
        if (singleObject.categoryName == "Net Banking") {
          this.bankDropdownItemList = singleObject.paymentModeCategories;
        }
      }

    });
  }


  getBankAccountList() {
    this.remittanceService.getBankAccountList().subscribe(resp => {
      this.bankAccountList = resp.body;
    });
  }

  
  getProfileList() {
   
  }

 

  proceedToNextPage(pageUrl) {
    this.router.navigate([pageUrl]);
  }
  
   letterOnly(event: KeyboardEvent) {
     var charCode = event.keyCode;
     if (((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8) || charCode == 32)
       return true;
     else return false;
   }
 
   onSubmit(form: any) {
    if (form.valid) {
      this.isFormSubmitted = true;
    } else {
      form.form.markAllAsTouched(); 
    }
  }
 
 markAllFieldsAsTouched(form: NgForm) {
   Object.values(form.controls).forEach(control => {
     control.markAsTouched();  
   });
 }
 onCheckboxChange() {
    console.log('Checkbox state:', this.isChecked);
  }
  openModal() {
    this.modalService.open(this.eSIMCardModal, { centered: true , size: 'md'});
  }

  openSuccessModal() {
    this.modalService.open(this.eSimSuccessModal , { centered: true , size: 'md'});
  }
  
  closeModalAndNavigate() {
    this.modalService.dismissAll();
    // Add navigation logic here, e.g., using Angular Router
    // this.router.navigate(['/some-route']);
  }
  onSubmit1(form: any) {
    if (form.valid) {
      console.log("Form submitted successfully", this.addBankAccountRequest);
      
      // Reset the form
      form.resetForm();
    } else {
      console.log("Form submission failed. Please check the required fields.");
    }
  }

  openModalForAddBankAccount(addBankModal) {
    this.addBankAccountRequest.branch = null;
    this.modalReference = this.modalService.open(addBankModal, { size: 'lg', centered: true });

  }

  buyESimProceed() {
    


  }

  validateESIMProceed() {
    /* if(!this.simType) {
      this.toast.error("Please select sim type");
      return false;
    } */
    if(!this.paymentMode) {
      this.toast.error("Please select payment mehtod");
      return false;
    }
    if(this.paymentMode=='NB' && !this.bankAccountId) {
      this.toast.error("Please select bank account");
      return false;
    }
    return true;
  }

  updateSimType() {

    /* if(this.isRetryPayment) {

      this.callPaymentGatewayForEsim()
    } else { */
      this.eSIMOrderId = this.eSIMOrderData.id;
      if(this.validateESIMProceed()) {
          this.callPaymentGatewayForEsim();
        /* this.cardService.updateSimType(this.eSIMOrderId, this.simType).subscribe(resp => {
        let orderType = { "ORDER_TYPE" : "ESIM", "ORDER_ID": this.eSIMOrderId };
        localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));
        this.callPaymentGatewayForEsim();
      }, err => {
        this.showLoader = false;
        console.log(err);
        this.toast.error(err.error.message);
      }); */
    }
    /* } */


  }

  callPaymentGatewayForEsim() {

    this.showLoader = true;
    // this.getSessionData();


    /* if(this.paymentMode == "NB") {
      this.cardService.callPaymentGatewayForEsim(this.eSIMOrderId, this.bankAccountId).subscribe(resp => {
        console.log(resp);
      }, err => {
        this.showLoader = false;
        if (err.status == 200) {
          var responsePaymentLinkBody = JSON.parse(this.cryptoUtils.resDecrypt(err.error.text));
          localStorage.setItem(ConstantsKey.IS_ESIM_ORDER_DONE, "IN_PROCESS");
          window.location.href = responsePaymentLinkBody.payment_link;
        } else {
          // console.log("err callQuotation >", err);
          this.toast.error(err.error.message);
        }
      });
    } else if(this.paymentMode == "UPI") { */

      // let productType = this.simType == "E-SIM" ? "E_SIM" : "INTERNATIONAL_SIM_CARD";

      let productType = "E_SIM";
      let requestObj = {
        'paymentType': this.paymentMode,
        'orderId': this.eSIMOrderId,  
        'product': productType,
        'deviceType': 'WEB',
        'orderType': productType
      };

      if(this.paymentMode=="NB"){
        requestObj['bankId']=  this.bankAccountId;
      }

      this.orderService.getPayUOtherLink(requestObj).subscribe(resp => {
        this.showLoader = false;
        let orderType = { "ORDER_TYPE" : "ESIM", "ORDER_ID": this.eSIMOrderId };
        localStorage.setItem(ConstantsKey.CURRENT_ORDER_TYPE, JSON.stringify(orderType));
        
        var respUPIPayLinkData = JSON.parse(JSON.stringify(resp.body));
        localStorage.setItem(ConstantsKey.IS_ESIM_ORDER_DONE, "IN_PROCESS");
        // window.location.href = respUPIPayLinkData.redirectionURL;

        if(respUPIPayLinkData.status == "SUCCESS") {
          // if(this.paymentMode == "NB") {
          //   this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
          //   document.open();          
          //   document.write(this.NBPaymentHtml);
          //   document.close();
          // } else if(this.paymentMode == "UPI") {
          //   window.location.href = respUPIPayLinkData.redirectionURL;
          // }
          if (respUPIPayLinkData.redirectionURL) {
            window.location.href = respUPIPayLinkData.redirectionURL;
          } else {
            this.NBPaymentHtml = respUPIPayLinkData.htmlCode;
            document.open();
            document.write(this.NBPaymentHtml);
            document.close();
          }
        } else if(respUPIPayLinkData.status == "ERROR") {
          let errMsg:string = respUPIPayLinkData.errorDescription;
          if(errMsg.includes("not support PayU")) {
            this.callPaymentGateway();
          }
        }


      }, err => {
          // console.log(" ", err);
          this.toast.error(err.error.message);
      });
    /* } */

  }
  opendevicesModal() {
    this.modalService.open(this.devicesModal, { size: 'sm', windowClass: 'centered-modal' });
  }

  callPaymentGateway() {
      this.cardService.callPaymentGatewayForEsim(this.eSIMOrderId, this.bankAccountId).subscribe(resp => {
        console.log(resp);
      }, err => {
        this.showLoader = false;
        if (err.status == 200) {
          var responsePaymentLinkBody = JSON.parse(this.cryptoUtils.resDecrypt(err.error.text));
          localStorage.setItem(ConstantsKey.IS_ESIM_ORDER_DONE, "IN_PROCESS");
          window.location.href = responsePaymentLinkBody.payment_link;
        } else {
          // console.log("err callQuotation >", err);
          this.toast.error(err.error.message);
        }
      });    
  }

}
